// extracted by mini-css-extract-plugin
export var box = "Partners-module--box--58e6b";
export var box_md = "Partners-module--box_md--c0310";
export var box_xmd = "Partners-module--box_xmd--0a4ed";
export var box_flex = "Partners-module--box_flex--e86e6";
export var box_lg = "Partners-module--box_lg--8a919";
export var box_sm = "Partners-module--box_sm--1bb23";
export var box_outer = "Partners-module--box_outer--0e5cb";
export var box_whiteBg = "Partners-module--box_white-bg--50701";
export var box_noMarginBottom = "Partners-module--box_no-margin-bottom--b296f";
export var box_noPadding = "Partners-module--box_no-padding--156ac";
export var box_outerGray = "Partners-module--box_outer-gray--6af91";
export var box_dark = "Partners-module--box_dark--b1680";
export var box_zIndex = "Partners-module--box_z-index--7eb9e";
export var box_zIndex6 = "Partners-module--box_z-index-6--c7051";
export var box_eventsWithLine = "Partners-module--box_events-with-line--0bda9";
export var box_featuresAo = "Partners-module--box_features-ao--0f7aa";
export var box_verticalPaddings = "Partners-module--box_vertical-paddings--35a45";
export var clearP = "Partners-module--clearP--911f9";
export var clearP_vc = "Partners-module--clearP_vc--97d52";
export var light = "Partners-module--light--0a7c5";
export var dark = "Partners-module--dark--59318";
export var layout = "Partners-module--layout--34eef";
export var horizontal = "Partners-module--horizontal--6809e";
export var header = "Partners-module--header--cbec9";
export var sliderWrapper = "Partners-module--sliderWrapper--90603";
export var description = "Partners-module--description--7aafc";
export var slide = "Partners-module--slide--c379d";
export var fadeInAnimation = "Partners-module--fadeInAnimation--63ae2";
export var placeHolderShimmer = "Partners-module--placeHolderShimmer--530b3";